











































































import { mapState } from 'vuex';
import * as ratingAPI from '@adobe/edex/frontend/api/rating';
export default {
  name: 'Ratings',
  components: {},
  props: [
    'ratings',
    'myRating',
    'detailedView',
    'entityID',
    'entityType',
    'createdBy',
  ],
  data() {
    return {
      ratingTemp: null,
      loading: false,
    };
  },
  computed: {
    ...mapState('member', ['member']),
    canRate() {
      return this.member && this.member.id !== this.createdBy;
    },
  },
  methods: {
    ratingActive(rating) {
      const isHover = this.ratingTemp !== null && this.ratingTemp >= rating;
      const isSelected = this.myRating !== null && this.myRating >= rating;
      return (isSelected && this.ratingTemp === null) || isHover;
    },
    async handleRatingClick(rating) {
      if (this.myRating === rating || this.loading) { return; }
      // optimistic update
      this.$emit('saved', { ratings: this.ratings, myRating: rating });
      this.loading = true;
      const {
        data: { myRating, ratings },
      } = await ratingAPI.rateEntity({
        entityType: this.entityType,
        entityID: this.entityID,
        rating,
      });
      this.loading = false;
      this.$emit('saved', { myRating, ratings });
    },
  },
};
